import { render, staticRenderFns } from "./home_m.vue?vue&type=template&id=480c40a0&scoped=true"
import script from "./home_m.vue?vue&type=script&lang=js"
export * from "./home_m.vue?vue&type=script&lang=js"
import style0 from "./home_m.vue?vue&type=style&index=0&id=480c40a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c40a0",
  null
  
)

export default component.exports